import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {AbsoluteFill, Easing, interpolate, useCurrentFrame} from 'remotion';

export const ExplorePlayerRecording20261027Composition = () => {
	const frame = useCurrentFrame();

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={410}
			style={{
				width: 1260,
				height: 1682,
			}}
		>
			<Video
				src="https://remotion.media/explore-remotion/player-source-2026-10-27-ba9239a0c58e.mp4"
				durationInFrames={410}
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[6, 9, 16, 21, 24, 70, 133, 141, 172, 258, 369, 383, 387],
					[
						'auto',
						'pointer',
						'auto',
						'pointer',
						'auto',
						'pointer',
						'auto',
						'grab',
						'grabbing',
						'grab',
						'auto',
						'pointer',
						'auto',
					],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 52, 56, 96, 104, 164, 258, 400, 406],
						[3, 2.7, 3, 2.7, 3, 2.7, 3, 2.7, 3],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
							23, 24, 25, 26, 27, 28, 29, 37, 38, 39, 40, 41, 42, 43, 44, 45,
							55, 56, 57, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72,
							73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 124, 125, 128, 129, 132,
							133, 136, 137, 140, 141, 143, 144, 147, 148, 150, 151, 154, 155,
							171, 172, 174, 175, 178, 179, 181, 182, 185, 186, 188, 189, 190,
							191, 193, 194, 196, 197, 199, 200, 201, 202, 204, 205, 207, 208,
							210, 211, 212, 213, 215, 216, 217, 218, 221, 222, 223, 224, 226,
							227, 229, 230, 232, 233, 235, 236, 238, 239, 241, 242, 243, 244,
							246, 247, 368, 369, 370, 372, 373, 375, 376, 379, 380, 382, 383,
							386, 387, 389, 390, 392, 393, 396, 397,
						],
						[
							'1230px 2563.59375px',
							'1223.47265625px 2548.76953125px',
							'1223.47265625px 2548.76953125px',
							'1178.8359375px 2503.8984375px',
							'1134.90234375px 2471.2265625px',
							'1130.671875px 2467.98046875px',
							'1125.97265625px 2463.9375px',
							'1115.66015625px 2455.51171875px',
							'1094.96484375px 2441.37890625px',
							'1033.06640625px 2401.921875px',
							'978.38671875px 2367.0234375px',
							'973.18359375px 2363.63671875px',
							'955.20703125px 2351.30859375px',
							'923.51953125px 2331.17578125px',
							'870.03515625px 2299.46484375px',
							'836.7890625px 2280.328125px',
							'816.15234375px 2266.546875px',
							'793.72265625px 2249.2265625px',
							'764.33203125px 2228.859375px',
							'734.63671875px 2212.06640625px',
							'689.49609375px 2189.34375px',
							'687.9609375px 2188.58203125px',
							'687.9609375px 2188.58203125px',
							'684.78515625px 2187.31640625px',
							'684.78515625px 2187.31640625px',
							'680.2734375px 2185.95703125px',
							'642.38671875px 2173.67578125px',
							'583.5234375px 2152.21875px',
							'563.00390625px 2144.09765625px',
							'504.4921875px 2114.09765625px',
							'504.4921875px 2114.09765625px',
							'483.65625px 2101.27734375px',
							'482.63671875px 2100.5390625px',
							'482.63671875px 2100.5390625px',
							'480px 2098.59375px',
							'480px 2098.59375px',
							'480px 2098.59375px',
							'375.97265625px 1909.41796875px',
							'313.72265625px 1814.82421875px',
							'313.72265625px 1814.82421875px',
							'250.6875px 1691.37890625px',
							'238.74609375px 1650.71484375px',
							'229.81640625px 1616.94140625px',
							'225.1875px 1596.4921875px',
							'221.61328125px 1573.55859375px',
							'221.33203125px 1566.05859375px',
							'220.6875px 1549.828125px',
							'220.6875px 1542.08203125px',
							'220.6875px 1531.1484375px',
							'220.6875px 1523.9765625px',
							'220.88671875px 1514.0625px',
							'221.33203125px 1506.31640625px',
							'221.51953125px 1502.0859375px',
							'221.63671875px 1500.45703125px',
							'221.6953125px 1499.44921875px',
							'221.6953125px 1497.85546875px',
							'221.6953125px 1497.03515625px',
							'221.6953125px 1496.6015625px',
							'221.6953125px 1496.484375px',
							'221.6953125px 1496.484375px',
							'234.73828125px 1476.38671875px',
							'234.73828125px 1476.38671875px',
							'321.3984375px 1410.984375px',
							'321.3984375px 1410.984375px',
							'395.19140625px 1359.4921875px',
							'395.19140625px 1359.4921875px',
							'431.0859375px 1334.4140625px',
							'431.0859375px 1334.4140625px',
							'445.7109375px 1321.32421875px',
							'445.7109375px 1321.32421875px',
							'462.31640625px 1304.5078125px',
							'462.31640625px 1304.5078125px',
							'469.67578125px 1293.7265625px',
							'469.67578125px 1293.7265625px',
							'471.22265625px 1288.23046875px',
							'471.22265625px 1288.23046875px',
							'471.45703125px 1287.69140625px',
							'471.45703125px 1287.69140625px',
							'471.0234375px 1285.06640625px',
							'471.0234375px 1285.06640625px',
							'469.81640625px 1274.63671875px',
							'469.81640625px 1274.63671875px',
							'468.84375px 1259.0859375px',
							'468.84375px 1259.0859375px',
							'468.10546875px 1219.3359375px',
							'468.10546875px 1219.3359375px',
							'467.51953125px 1188.9609375px',
							'467.51953125px 1188.9609375px',
							'465.75px 1149.421875px',
							'465.75px 1149.421875px',
							'463.7109375px 1086.3515625px',
							'463.7109375px 1086.3515625px',
							'455.296875px 991.04296875px',
							'455.296875px 991.04296875px',
							'446.8125px 937.4296875px',
							'446.8125px 937.4296875px',
							'437.4609375px 869.578125px',
							'437.4609375px 869.578125px',
							'435.9375px 849.140625px',
							'435.9375px 849.140625px',
							'435.17578125px 823.21875px',
							'435.17578125px 823.21875px',
							'435.17578125px 803.54296875px',
							'435.17578125px 803.54296875px',
							'435.17578125px 780.796875px',
							'435.17578125px 780.796875px',
							'435.5625px 763.03125px',
							'435.5625px 763.03125px',
							'435.5625px 743.765625px',
							'435.5625px 743.765625px',
							'435.5625px 730.4296875px',
							'435.5625px 730.4296875px',
							'435.5625px 710.6484375px',
							'435.5625px 710.6484375px',
							'434.0859375px 689.19140625px',
							'434.0859375px 689.19140625px',
							'432.62109375px 665.42578125px',
							'432.62109375px 665.42578125px',
							'431.61328125px 651.55078125px',
							'431.61328125px 651.55078125px',
							'430.7109375px 632.34375px',
							'430.7109375px 632.34375px',
							'430.37109375px 619.86328125px',
							'430.37109375px 619.86328125px',
							'430.37109375px 614.28515625px',
							'430.37109375px 614.28515625px',
							'430.125px 612.97265625px',
							'430.125px 612.97265625px',
							'430.125px 611.61328125px',
							'430.125px 611.61328125px',
							'430.125px 611.0859375px',
							'430.125px 611.0859375px',
							'1291.95703125px 2296.06640625px',
							'1291.03125px 2310.97265625px',
							'1291.03125px 2310.97265625px',
							'1288.25390625px 2350.96875px',
							'1288.25390625px 2350.96875px',
							'1283.05078125px 2432.53125px',
							'1283.05078125px 2432.53125px',
							'1282.83984375px 2481.83203125px',
							'1282.83984375px 2481.83203125px',
							'1282.453125px 2526.52734375px',
							'1282.453125px 2526.52734375px',
							'1281.4921875px 2554.44140625px',
							'1281.4921875px 2554.44140625px',
							'1281.4921875px 2574.62109375px',
							'1281.4921875px 2574.62109375px',
							'1280.8359375px 2584.48828125px',
							'1280.8359375px 2584.48828125px',
							'1280.8125px 2586.2109375px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};
